<cft-dialog *transloco="let t" [title]="t('createJobRequest.close.title')">
  <cft-dialog-content>
    <div>{{ t('createJobRequest.close.description') }}</div>
    <div class="mt-xl flex">
      <div>
        <fa-icon [icon]="phoneIcon"></fa-icon>
      </div>
      <div class="ml-sm text-base">
        <div class="font-bold">{{ t('createJobRequest.close.contact.title') }}</div>
        <div>
          <a [href]="t('shared.support.email') | bgoMailTo">{{ t('shared.support.email') }}</a>
        </div>
        <div>
          <a [href]="t('shared.support.phone') | bgoTel">
            {{ t('shared.support.phone') }}
          </a>
          ({{ t('shared.support.operatingHours') }})
        </div>
      </div>
    </div>
  </cft-dialog-content>
  <cft-dialog-footer>
    @if (i18nService.getActiveLang() === 'de') {
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://t.maze.co/262972631"
        class="btn-sm btn btn-secondary"
        data-testid="exit-job-survey-link"
      >
        {{ t('createJobRequest.close.surveyLinkText') }}
      </a>
    }
    <button type="button" class="btn-sm btn btn-hero" (click)="close()" data-testid="exit-job-request-button">
      {{ exitButtonText }}
    </button>
  </cft-dialog-footer>
</cft-dialog>
